import { c as _c } from "react/compiler-runtime";
import { SphereIconButton } from "@components/common/sphere-icon-button";
import { useMarkupContext } from "@context-providers/markup/markup-context";
import { AttachmentIcon, Text } from "@flat-ui";
import { Box } from "@mui-wrapper";
import { useState } from "react";
import { PALETTE_VARS } from "@styles/palette-vars";

/**
 * The MarkupAttachments component shows the number of attachments and displays a different
 * message when hovered.
 * When clicked, it opens a side panel and updates the selected markup.
 *
 * @param {BaseMarkupProps} markup - The markup object containing the attachments.
 * @returns {JSX.Element} The rendered component displaying the number of attachments and an icon.
 */
export function MarkupAttachments(t0) {
  const $ = _c(24);
  const {
    markup
  } = t0;
  const [isHovered, setIsHovered] = useState(false);
  const {
    updateSelectedMarkup,
    updateIsSidePanelOpen,
    updateActiveTab
  } = useMarkupContext();
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      pl: "10px",
      display: "flex",
      alignItems: "center"
    };
    t2 = () => setIsHovered(true);
    t3 = () => setIsHovered(false);
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== markup || $[4] !== updateActiveTab || $[5] !== updateIsSidePanelOpen || $[6] !== updateSelectedMarkup) {
    t4 = event => {
      event.stopPropagation();
      updateIsSidePanelOpen(true);
      updateSelectedMarkup(markup);
      updateActiveTab("Attachments");
    };
    $[3] = markup;
    $[4] = updateActiveTab;
    $[5] = updateIsSidePanelOpen;
    $[6] = updateSelectedMarkup;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      display: "flex",
      alignItems: "center",
      gap: "10px"
    };
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = isHovered ? "primary.main" : PALETTE_VARS.text.disabled;
  const t7 = isHovered ? PALETTE_VARS.action.hover : "none";
  let t8;
  if ($[9] !== t7) {
    t8 = {
      sx: {
        backgroundColor: t7
      }
    };
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t6 || $[12] !== t8) {
    t9 = <SphereIconButton component={AttachmentIcon} buttonSize="22px" iconSize="14px" color={t6} iconButtonProps={t8} />;
    $[11] = t6;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const t10 = !isHovered && markup.attachmentsCount;
  let t11;
  if ($[14] !== t10 || $[15] !== t9) {
    t11 = <Box component="div" sx={t5} data-testid="markup-attachments-content">{t9}{t10}</Box>;
    $[14] = t10;
    $[15] = t9;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== isHovered || $[18] !== markup) {
    t12 = isHovered && <Text variant="bodyS" component="span" sx={{
      pl: "8px",
      color: "primary.main",
      textDecoration: "underline"
    }} data-testid="markup-attachments-label">{markup.attachmentsCount ? "View attachments" : "Add attachments"}</Text>;
    $[17] = isHovered;
    $[18] = markup;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t11 || $[21] !== t12 || $[22] !== t4) {
    t13 = <Box component="div" sx={t1} onMouseEnter={t2} onMouseLeave={t3} onClick={t4} data-testid="markup-attachments">{t11}{t12}</Box>;
    $[20] = t11;
    $[21] = t12;
    $[22] = t4;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  return t13;
}